import { AppState } from '../..';
import { DismissibleWarning } from '@fullstory/client-api';
import { createSelector } from 'reselect';
import { groupBy } from 'lodash';
import moment from 'moment';

const getInsightsMap = (state: AppState) => state.metricsInsights.metricInsights;

const getSavedInsights = createSelector(getInsightsMap, insights => Object.values(insights));

export const getInsightsByDxIdHash = createSelector(getSavedInsights, insights => {
  const sortedInsights =
    !insights || insights.length == 0
      ? []
      : [...insights].sort((a, b) => moment(b.createdAt as string).diff(a.createdAt as string));
  return groupBy(sortedInsights, insight => insight.dxIdObjectHash);
});

export const getCheckedForInsights = (state: AppState) => state.metricsInsights.checkedForInsights;

export const getInsightDetailViewResponse = (state: AppState) =>
  state.metricsInsights.insightDetailViewResponse;

export const getShowMetricInsightSaveWarning = (state: AppState) =>
  state.settings.seatSettings.DismissedWarnings
    ? state.settings.seatSettings.DismissedWarnings.find(
        w => w === DismissibleWarning.WarningMetricSaveDeleteInsights,
      ) === undefined
    : true;
